import React from 'react';
import { site } from '../data/site';
import { IconAppStore, IconGithub, IconLinkedin, IconMail, IconPlayStore } from './Icons';

const iconFor = (label: string) => {
  if (label === 'GitHub') return <IconGithub />;
  if (label === 'LinkedIn') return <IconLinkedin />;
  if (label === 'Play Store') return <IconPlayStore />;
  if (label === 'App Store') return <IconAppStore />;
  return <IconMail />;
};

export const SocialLinks: React.FC<{ className?: string }> = ({ className = '' }) => (
  <ul className={`social-links ${className}`.trim()}>
    {site.social.map((item) => (
      <li key={item.href}>
        <a href={item.href} target="_blank" rel="noopener noreferrer" aria-label={item.label}>
          {iconFor(item.label)}
        </a>
      </li>
    ))}
    {site.stores.map((item) => (
      <li key={item.href}>
        <a href={item.href} target="_blank" rel="noopener noreferrer" aria-label={item.label}>
          {iconFor(item.label)}
        </a>
      </li>
    ))}
    <li>
      <a href={`mailto:${site.email}`} aria-label="E-posta">
        <IconMail />
      </a>
    </li>
  </ul>
);
